export default "Penguin Escape åbnede i juli 2020.";